/* WeldRda: on the homepage, links to the homepage = back to the top (travail 17-18, 18 Oct 2026).
   Loaded in layout/theme.liquid.
   Hamza: tapping the logo at the bottom of the homepage did nothing on iPhone (fine on computer): first the header
   logo (fixed in travail 17), then the footer logo (travail 18).
   Both logos link to "/", the page you are already on. iPhone (Safari and the Instagram / Facebook browsers) treats
   that as a reload and puts you back at the same scroll position, so the page looked unchanged.
   Now, on the homepage, any link to the homepage (header logo, footer logo, "Accueil") scrolls smoothly to the top
   instead of reloading. On other pages these links work as normal and open the homepage. */
(function () {
'use strict';
if (window.__wrHomeLogo) return;
window.__wrHomeLogo = true;
document.addEventListener('click', function (e) {
  if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  var a = e.target.closest && e.target.closest('a[href]');
  if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
  var url;
  try { url = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (url.origin !== location.origin || url.pathname !== root || location.pathname !== root || url.search || url.hash) return;
  e.preventDefault();
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var opts = { top: 0, left: 0, behavior: reduce ? 'auto' : 'smooth' };
  /* Phones scroll the window; computers scroll .page-wrapper (Horizon). */
  var pw = document.querySelector('.page-wrapper');
  if (pw && pw.scrollTop > 0) pw.scrollTo(opts);
  if (window.scrollY > 0) window.scrollTo(opts);
});
})();